import React, { useState } from 'react';
import { Link } from '@theme/js/components/common/Link';

import style from './NavigationBar.scss';

export const ActiveSubMenu = ({ name, items, classNames, isActive }) => {

    const defaultMenuState = items.some(isActive);
    const [isOpen, setIsOpen] = useState(defaultMenuState);

    return (
        <>
            <Link
                className={classNames}
                onClick={() => setIsOpen(!isOpen)}>
                <span className={style.itemName}>{name}</span>
            </Link>

            {isOpen && (
                <div className={style.navBarOpen}>
                    <ul className={style.nestedLinksContainer}>
                        {items.map((item, index) => (
                            <span key={index}
                                  className={`${style.navigationBarNestedLink} ${item.cssClasses ? `${item.cssClasses}` : ''}`}
                                  data-url={item.url}
                                  {...(item.dyUnit ? { 'data-dyUnit': `${item.dyUnit}` } : {})}
                            >
                                <span className={`${style.nestedLinkIcon}`} />
                                 <Link
                                     href={item.url}
                                     className={`${style.link} ${style.listItemPoint}`}
                                 >
                                    <span className={`${style.navigationBarNestedLink} ${isActive(item) ? `${style.isActiveLinkNew}` : ''}`}>{item.name}</span>
                                </Link>
                            </span>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
};
